// extracted by mini-css-extract-plugin
export default {"icon":"ValueComponentWithIcon__icon___NBD1Y","label":"ValueComponentWithIcon__label___MTbR2"};